import React from "react";
import { LuPaperclip as Paperclip } from "react-icons/lu";

import { PostWithUser } from "../../types/index.type";

// Attachments Component
type AttachmentsProps = {
  attachments: PostWithUser["post"]["attachments"];
};

export const Attachments = ({ attachments }: AttachmentsProps) => {
  if (!attachments || attachments.length === 0) return null;

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2">
        <Paperclip className="h-4 w-4 text-gray-500" />
        <h4 className="font-semibold text-gray-900">Attachments ({attachments.length})</h4>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {attachments.map((attachment, index) => (
          <div
            key={index}
            className="group relative overflow-hidden rounded-xl border border-gray-200 hover:border-gray-300 transition-colors"
          >
            {attachment.fileType === "IMAGE" ? (
              <img
                src={attachment.fileUrl}
                alt={`Attachment ${index + 1}`}
                className="w-full h-32 object-cover group-hover:scale-105 transition-transform duration-300"
              />
            ) : attachment.fileType === "VIDEO" ? (
              <video
                src={attachment.fileUrl}
                className="w-full h-32 object-cover rounded-lg"
                controls
                preload="metadata"
              />
            ) : null}
          </div>
        ))}
      </div>
    </div>
  );
};
